import { UserRole } from '../../auth/types/auth.types';

export interface User {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  branchOffice?: number;
  branchOfficeName?: string;
  userCode?: string;
  externalUserId?: string;
  chainId?: string;
  regionId?: string;
  employeeNumber?: number;
  roleDisplay?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateUserRequest {
  email: string;
  password: string;
  role: UserRole;
  branchOffice?: number;
  branchOfficeName?: string;
  userCode?: string;
  externalUserId?: string;
  chainId?: string;
  regionId?: string;
  employeeNumber?: number;
  name?: string;
  requiresPasswordChange?: boolean;
}

export interface UpdateUserRequest {
  email?: string;
  password?: string;
  branchOffice?: number;
  branchOfficeName?: string;
  userCode?: string;
  role?: UserRole;
  externalUserId?: string;
  chainId?: string;
  regionId?: string;
  employeeNumber?: number;
  name?: string;
  requiresPasswordChange?: boolean;
}

/** Empleado de la plantilla BUK (GET /employees). */
export interface Employee {
  numeroColaborador: number | null;
  fullName: string | null;
  puesto: string | null;
  area: string | null;
  recinto: string | null;
  unidadNegocio: string | null;
  email: string | null;
  status: string | null;
}

export interface UsersState {
  users: User[];
  currentUser: User | null;
  isLoading: boolean;
  formLoading: boolean;
  error: string | null;
}

/**
 * Opciones de rol para el alta de usuarios.
 *
 * OJO: la cuenta de vendedor de una tienda es BRANCH_OFFICE (cuenta COMPARTIDA;
 * el vendedor real se elige en el selector, que sale de BUK/Proscai). El rol
 * SELLER NO se ofrece: no lo usa nadie (0 usuarios en produccion) y crear una
 * cuenta con ese rol produce un usuario que no opera.
 *
 * INDICADORES (2026-07-29) es de SOLO LECTURA del tablero: entra al admin y ve
 * unicamente /indicadores (Global + Tienda). No administra usuarios ni
 * sucursales — el backend lo deja fuera de todos los endpoints de escritura y
 * el menu no le muestra esas secciones. NO requiere cadena/sucursal, igual que
 * Administrador.
 */
export const roleOptions = [
  { label: 'Vendedor (cuenta de tienda)', value: UserRole.BRANCH_OFFICE },
  { label: 'Bodeguero', value: UserRole.WAREHOUSE_STAFF },
  { label: 'Consulta', value: UserRole.CONSULTA },
  { label: 'Gerente', value: UserRole.MANAGER },
  { label: 'Indicadores (solo analiticas)', value: UserRole.INDICADORES },
  { label: 'Administrador', value: UserRole.ADMIN },
];

export type ImportEstado =
  | 'crear'
  | 'omitir'
  | 'error'
  | 'creada'
  | 'omitida';

export interface ImportResuelto {
  role: string;
  branchOffice?: number;
  chainId?: string;
  branchOfficeName?: string;
  regionId?: string;
}

export interface ImportRow {
  linea: number;
  email: string;
  estado: ImportEstado;
  motivo: string | null;
  resuelto: ImportResuelto | null;
}

export interface ImportSummary {
  total: number;
  aCrear: number;
  omitidas: number;
  conError: number;
  creadas?: number;
}

export interface ImportReport {
  summary: ImportSummary;
  rows: ImportRow[];
}

export interface ImportDefaults {
  password?: string;
  requiresPasswordChange?: boolean;
}
